import React, { useState } from "react";
import { IconButton, Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, FormControlLabel, Switch } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import { useApproverUpdateMutation } from "../../../../../services/ticketEasyService/ticketEasy-api";
import { TicketApprover } from "../../../../../services/ticketEasyService/model/ticketEasy/ticketApprover/TicketApprover";
import { useDispatch } from "react-redux";

interface ApproverEditProps {
    approver: TicketApprover;
    onSuccess?: () => void;
    onError?: (error: string) => void;
}

export const ApproverEdit: React.FC<ApproverEditProps> = ({
    approver,
    onSuccess,
    onError,
}) => {
    const [dialogOpen, setDialogOpen] = useState(false);
    const [updatedApprover, setUpdatedApprover] = useState<TicketApprover>({
        ...approver,
        isPrimary: approver.isPrimary || false,
    });
    const [updateApprover, { isLoading }] = useApproverUpdateMutation();
    const dispatch = useDispatch();

    const handleDialogOpen = () => setDialogOpen(true);
    const handleDialogClose = () => setDialogOpen(false);

    const handleInputChange = (field: keyof TicketApprover, value: string | number | string[] | boolean) => {
        setUpdatedApprover({ ...updatedApprover, [field]: value });
    };

    const handleSave = async () => {
        try {
            await updateApprover({
                approver: updatedApprover
            }).unwrap();
            if (onSuccess) onSuccess();
            alert("Approver updated successfully!");
            handleDialogClose();
        } catch (error: any) {
            if (onError) onError(error.message);
            alert("Failed to update approver: " + error.message);
        }
    };

    return (
        <>
            <IconButton onClick={handleDialogOpen} color="primary" aria-label="edit approver">
                <EditIcon />
            </IconButton>
            <Dialog open={dialogOpen} onClose={handleDialogClose} fullWidth maxWidth="sm">
                <DialogTitle>Edit Approver</DialogTitle>
                <DialogContent>
                    <TextField
                        label="Name"
                        value={updatedApprover.name}
                        fullWidth
                        margin="normal"
                        InputProps={{
                            readOnly: true,
                        }}
                    />
                    <TextField
                        label="Email"
                        value={updatedApprover.email}
                        fullWidth
                        margin="normal"
                        InputProps={{
                            readOnly: true,
                        }}
                    />
                    <FormControlLabel
                        control={
                            <Switch
                                checked={updatedApprover.isPrimary}
                                onChange={(e) => handleInputChange("isPrimary", e.target.checked)}
                                color="primary"
                            />
                        }
                        label="Primary Approver"
                        sx={{ marginTop: 2 }}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleDialogClose} color="secondary">
                        Cancel
                    </Button>
                    <Button onClick={handleSave} color="primary" disabled={isLoading}>
                        {isLoading ? "Saving..." : "Save"}
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};
